export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-add-to-cart').forEach((el) => {
      el.addEventListener('click', (event) => {
        // POST /ec/cart/line_item with form data line_item[product_id]=1&line_item[quantity]=1
        let quantity = el.dataset.quantity
        if (el.dataset.quantityEl) {
          quantity = document.querySelector(el.dataset.quantityEl).value
        }
        if (!quantity) {
          quantity = 1
        }
        let formData = new FormData()
        if (el.dataset.discountRemoveIdentity) {
          formData.append('line_item[line_item_type]', 'discount')
          formData.append(
            'line_item[item_identity]',
            el.dataset.discountRemoveIdentity
          )
          formData.append('line_item[_destroy]', 'true')
        } else {
          let itemType = el.dataset.itemType
          if (el.dataset.itemTypeEl) {
            itemType = document.querySelector(el.dataset.itemTypeEl).value
          }
          formData.append('line_item[item_type]', itemType || 'product')
          let itemId = el.dataset.itemId
          if (el.dataset.itemIdEl) {
            itemId = document.querySelector(el.dataset.itemIdEl).value
          }
          formData.append('line_item[item_id]', itemId)
          formData.append('line_item[quantity]', quantity)
        }
        fetch('/ec/cart/line_item.json', {
          method: 'POST',
          body: formData,
        }).then((res) => {
          res.json().then((data) => {
            // trigger event 'odims:cart:line_item:added'
            document.dispatchEvent(
              new CustomEvent('odims:cart:line_item:added', {
                detail: data,
              })
            )
          })
        })
        event.preventDefault()
        event.stopPropagation()
        return false
      })
    })
  })
})()
